module.exports = __webpack_public_path__ + "img/xlsm.0933aeb8.svg";